import { mutate } from 'swr';

import { getCurrentLanguage } from '~/localization';

import {
  getCustomEmployeeFieldAttributes,
  getCustomEmployeeFieldLanguages,
  getCustomEmployeeFields,
} from '.';

export const prefetchCustomData = (empId: string) => {
  const currentLanguage = getCurrentLanguage();
  mutate(['customEmployeeFields', empId], getCustomEmployeeFields(empId));
  mutate(
    ['customEmployeeFieldLanguages', currentLanguage],
    getCustomEmployeeFieldLanguages(currentLanguage),
  );
  mutate(
    'customEmployeeFieldsFieldAttributes',
    getCustomEmployeeFieldAttributes(),
  );
};
